import { FC } from 'react'
import { AddressData } from '@wellesley/openapi'

type PostLocationProps = {
  address: AddressData
}

const PostLocation: FC<PostLocationProps> = ({ address }) => {
  if (!address?.formatted) return null

  return (
    <div
      data-testid="post-location"
      className="mt-s text-sm font-medium text-gray-500"
    >
      {address.formatted}
    </div>
  )
}

export default PostLocation
